"use strict";

angular.module('app.modals.device.heatingCurvePreset', [])

    .controller('heatingCurvePresetModalCtrl', ['$scope','close','selectedPreset',
        function ($scope,close,selectedPreset) {
            const defaultValue = 1;

            Number.isNaN = Number.isNaN || function(value) {
                return value !== value;
            };

            if (selectedPreset
                && !Number.isNaN(+selectedPreset)) {
                    $scope.selectedPreset = +selectedPreset;
            }
            else {
                $scope.selectedPreset = defaultValue;
            }

            $scope.close = function(a)
            {
                close(a);
            };

            function parseValue(value) {
                if ((typeof(value) === 'number') && Number.isInteger(value)) {
                    return parseInt(value, 10);
                }
                else {
                    return defaultValue;
                }
            }

            $scope.validateInput = function() {
                if (!$scope.selectedPreset) {
                    return;
                }
                let parsed = parseValue($scope.selectedPreset);
                if (parsed < 1) {
                    $scope.selectedPreset = 1;
                }
                else if (parsed > 40) {
                    $scope.selectedPreset = 40;
                }
            };
            $scope.isInputValid = function() {
                if (!$scope.selectedPreset) {
                    return false;
                }
                let parsed = parseValue($scope.selectedPreset);
                if (parsed >= 1 && parsed <= 40) {
                    return true;
                }
                else {
                    return false;
                }
            };

            $scope.calculatePreset = function () {
                close($scope.selectedPreset);
            };
        }
    ])

    .factory('heatingCurvePresetModal', ['ModalService', function (ModalService) {
        return function (selectedPreset) {
            return ModalService.showModal({
                templateUrl: "views/modals/device.heatingCurvePreset.html",
                controller: 'heatingCurvePresetModalCtrl',
                inputs: {
                    selectedPreset: selectedPreset
                }
            });
        };
    }]);
